import isArray from 'lodash/isArray'
import isObject from 'lodash/isObject'
import mapValues from 'lodash/mapValues'

const handleLinks = (links, slug) => {
  const replacer = ({ url, mode }) => {
    if (mode === 'internal' && url) return`/${slug}/${url}`
    return url
  }
  if (isArray(links)) {
    return links.reduce((obj, link, id) => {
      obj[link.id || id] = {
        ...link,
        url: replacer(link),
      }
      return obj
    }, {})
  }
  if (isObject(links)) {
    return mapValues(links, (link, id) => ({
      ...link,
      id,
      url: replacer(link),
    }))
  }
  return links
}

export default handleLinks
